/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Color_Image_Input_Upload_PhotoInputs */

const en_admin_resources_color_image_input_upload_photo = /** @type {(inputs: Admin_Resources_Color_Image_Input_Upload_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload image`)
};

const de_admin_resources_color_image_input_upload_photo = /** @type {(inputs: Admin_Resources_Color_Image_Input_Upload_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild hochladen`)
};

const es_admin_resources_color_image_input_upload_photo = /** @type {(inputs: Admin_Resources_Color_Image_Input_Upload_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir imagen`)
};

const fr_admin_resources_color_image_input_upload_photo = /** @type {(inputs: Admin_Resources_Color_Image_Input_Upload_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger une image`)
};

const nl_admin_resources_color_image_input_upload_photo = /** @type {(inputs: Admin_Resources_Color_Image_Input_Upload_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto uploaden`)
};

/** @type {(inputs: Admin_Resources_Color_Image_Input_Upload_PhotoInputs) => LocalizedString} */
const it_admin_resources_color_image_input_upload_photo = en_admin_resources_color_image_input_upload_photo;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Upload_PhotoInputs) => LocalizedString} */
const pt_br2_admin_resources_color_image_input_upload_photo = en_admin_resources_color_image_input_upload_photo;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Upload_PhotoInputs) => LocalizedString} */
const pl_admin_resources_color_image_input_upload_photo = en_admin_resources_color_image_input_upload_photo;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Upload_PhotoInputs) => LocalizedString} */
const hu_admin_resources_color_image_input_upload_photo = en_admin_resources_color_image_input_upload_photo;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Upload_PhotoInputs) => LocalizedString} */
const ro_admin_resources_color_image_input_upload_photo = en_admin_resources_color_image_input_upload_photo;

/**
* | output |
* | --- |
* | "Upload image" |
*
* @param {Admin_Resources_Color_Image_Input_Upload_PhotoInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_color_image_input_upload_photo = /** @type {((inputs?: Admin_Resources_Color_Image_Input_Upload_PhotoInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Color_Image_Input_Upload_PhotoInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_color_image_input_upload_photo(inputs)
	if (locale === "de") return de_admin_resources_color_image_input_upload_photo(inputs)
	if (locale === "es") return es_admin_resources_color_image_input_upload_photo(inputs)
	if (locale === "fr") return fr_admin_resources_color_image_input_upload_photo(inputs)
	if (locale === "nl") return nl_admin_resources_color_image_input_upload_photo(inputs)
	if (locale === "it") return it_admin_resources_color_image_input_upload_photo(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_color_image_input_upload_photo(inputs)
	if (locale === "pl") return pl_admin_resources_color_image_input_upload_photo(inputs)
	if (locale === "hu") return hu_admin_resources_color_image_input_upload_photo(inputs)
	return ro_admin_resources_color_image_input_upload_photo(inputs)
});
export { admin_resources_color_image_input_upload_photo as "admin.resources.color_image_input.upload_photo" }